// shifts-v1: ปุ่ม Clock-in/out (manual user action)
import React, { useState, useEffect } from 'react';
import API from '../api';
import toast from 'react-hot-toast';

function fmtDuration(seconds) {
  if (!seconds || seconds < 0) return '0m';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h === 0) return `${m}m`;
  return `${h}h ${m}m`;
}

export default function ClockButton({ compact = false, pending = null }) {
  const [status, setStatus] = useState({ active: false, current_session: null });
  const [loading, setLoading] = useState(false);
  const [tick, setTick] = useState(0); // re-render every minute

  async function load() {
    try {
      const { data } = await API.get('/api/time/status');
      setStatus(data);
    } catch (e) { /* silent */ }
  }

  // shifts-v1: ฟัง event จาก banner (auto refresh หลัง clock-in)
  useEffect(() => {
    load();
    const id = setInterval(load, 60_000);
    const tickId = setInterval(() => setTick(t => t + 1), 60_000);
    const onChange = () => load();
    window.addEventListener('clock-status-changed', onChange);
    return () => {
      clearInterval(id); clearInterval(tickId);
      window.removeEventListener('clock-status-changed', onChange);
    };
  }, []);

  async function clockIn() {
    setLoading(true);
    try {
      await API.post('/api/time/clock-in');
      toast.success('🟢 เข้างานแล้ว');
      await load();
    } catch (e) {
      toast.error(e.response?.data?.error || 'เข้างานไม่สำเร็จ');
    } finally { setLoading(false); }
  }

  async function clockOut() {
    if (!window.confirm('ออกงานเลย?')) return;
    setLoading(true);
    try {
      await API.post('/api/time/clock-out');
      toast.success('🔴 ออกงานแล้ว');
      await load();
    } catch (e) {
      toast.error(e.response?.data?.error || 'ออกงานไม่สำเร็จ');
    } finally { setLoading(false); }
  }

  const session = status.current_session;
  const seconds = session
    ? Math.floor((Date.now() - new Date(session.clock_in).getTime()) / 1000)
    : 0;

  if (!status.active) {
    return (
      <>
        {pending && (
          <style>{`
            @keyframes clockbtn-pulse-red {
              0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.6); transform: scale(1); }
              50% { box-shadow: 0 0 0 8px rgba(239, 68, 68, 0); transform: scale(1.05); }
            }
          `}</style>
        )}
        <button onClick={clockIn} disabled={loading}
          title={pending ? `⚠️ ยังไม่ได้กดเข้างาน — มีกะรออยู่` : 'เข้างาน'}
          style={{
            background: pending ? '#ef4444' : '#22c55e',
            color: '#fff', border: 'none',
            padding: compact ? '6px 10px' : '8px 14px',
            borderRadius: 8, cursor: loading ? 'wait' : 'pointer',
            fontSize: compact ? 12 : 13, fontWeight: 600,
            display: 'flex', alignItems: 'center', gap: 6,
            animation: pending ? 'clockbtn-pulse-red 1.5s ease-in-out infinite' : undefined,
          }}>
          {pending ? '🔴' : '🟢'} {compact ? '' : (pending ? 'เข้างานด่วน!' : 'เข้างาน')}
        </button>
      </>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      background: '#dcfce7', border: '1px solid #22c55e',
      padding: compact ? '4px 8px' : '5px 10px', borderRadius: 8,
    }}>
      <span style={{
        width: 8, height: 8, borderRadius: '50%', background: '#22c55e',
        animation: 'pulse 2s infinite',
      }} />
      <span style={{ fontSize: compact ? 11 : 12, color: '#166534', fontWeight: 600 }}>
        {fmtDuration(seconds)}
      </span>
      <button onClick={clockOut} disabled={loading}
        title="ออกงาน" style={{
          background: '#ef4444', color: '#fff', border: 'none',
          padding: '3px 8px', borderRadius: 4, cursor: loading ? 'wait' : 'pointer',
          fontSize: 11, fontWeight: 600, marginLeft: 4,
        }}>
        🔴 ออก
      </button>
    </div>
  );
}
